import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.notifications_index_page', () => {
  void import('./internal/field-avatar').then(({ default: Component }) => Component());
});
